// File Metadata:
// Filename: LoadingScreen.jsx
// Version: 1.00
// Created: 2025-06-20
// Last Modified: 2025-06-20
// Authors: Dieuwer Descheemaecker, GitHub Copilot
// Description: Full-screen branded loading screen using Obsidian Home design tokens

import React from 'react';
import { Box, CircularProgress, Typography, useTheme, alpha } from '@mui/material';

const LoadingScreen = ({ message = 'Loading…' }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        gap: 3,
      }}
    >
      {/* Glassmorphism card */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5,
          p: 5,
          borderRadius: 4,
          bgcolor: alpha(theme.palette.background.paper, 0.6),
          backdropFilter: 'blur(16px)',
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.2)}`,
        }}
      >
        {/* Teal spinner matching primary palette */}
        <CircularProgress
          size={48}
          thickness={4}
          sx={{
            color: 'primary.main',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />

        <Typography
          variant="body1"
          sx={{
            fontFamily: '"Epilogue", "Helvetica Neue", sans-serif',
            color: 'text.secondary',
            letterSpacing: '0.02em',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
